unable to read source [project]/packages/core/src/runtime/utils/normalizeCSSBucketEntry.ts